import {AdjustableColumns} from "../../../../palette/Palette";
import UsersList from "./UsersList";
import Permissions from "./Permissions";
import {inject, observer} from "mobx-react";
import {db} from "../../../../firebase/Firebase";
import {useCallback, useEffect, useRef, useState} from "react";
import {Filters,} from "../../../../utils/HelpFunctions";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function UsersPermissions(props) {

    const {DataStore} = props
    const {idCompany} = DataStore

    const [permissions, setPermissions] = useState([])
    const [dataUsers, setDataUsers] = useState([])
    const [selectedItemKeys, setSelectedItemKeys] = useState(null)
    const [userId, setUserId] = useState('')
    const [userName, setUserName] = useState('')
    const [ID, setID] = useState(null)
    const [trigger, setTrigger] = useState(false)

    const isMounted = useMountedState()

    useEffect(() => {

        const GetUsersData = async () => {
            const mainPath = db.collection('Users')
            let ID = 0
            await mainPath.where('idCompany', '==', idCompany).get()
                .then(snapshot => {
                    const users = []
                    let userObjects = {}
                    snapshot.forEach(doc => {
                        ID = ID + 1
                        userObjects = {...doc.data(), docId: doc.id, ID: ID}
                        users.push(userObjects);
                    })
                    const filterUser = Filters(users, 'status', true)
                    setDataUsers([...filterUser])
                    setPermissions([...filterUser[0].permits])
                    setSelectedItemKeys([filterUser[0].ID])
                    setUserId(filterUser[0].docId)
                    setUserName(filterUser[0].username)
                })
        }

        if (isMounted()) {
            GetUsersData().catch(() => setTrigger(!trigger))
        }

    }, [idCompany, isMounted, trigger])

    const onClickUser = (e) => {
        const userResult = Filters(dataUsers, 'ID', e.itemData.ID)
        setID(e.itemData.ID)
        setPermissions(userResult[0].permits)
        setSelectedItemKeys([e.itemData.ID])
        setUserId(e.itemData.docId)
        setUserName(e.itemData.username)
    }

    return (
        <>
            <AdjustableColumns color={'blues'} listWith={350}>
                {permissions.length > 0 &&
                <UsersList data={dataUsers} selectedItemKeys={selectedItemKeys} onClickUser={onClickUser}
                           ID={ID}/>}
                {permissions.length > 0 &&
                <Permissions permissions={permissions} userId={userId} setPermissions={setPermissions}
                             DataStore={DataStore}
                             userName={userName} setDataUsers={setDataUsers} data={dataUsers} ID={ID}/>}
            </AdjustableColumns>
        </>
    )

}

export default inject('DataStore')(observer(UsersPermissions));